'use client';

import { CSSProperties } from 'react';

import { UnitSystem } from '@ravago/shared/page-data/models/config';
import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableHead } from '@ravago/shared/radiance/components/table/components/TableHead/TableHead';
import { TableHeader } from '@ravago/shared/radiance/components/table/components/TableHeader/TableHeader';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { useBreakpoint } from '@ravago/shared/radiance/hooks/useBreakpoint/useBreakpoint';

import { AppUtils } from '../../../../utils/app/app.utils';

import { ProductCompareCardHeader } from './product-compare-card-header';
import { ProductCompareGeneralInfo } from './product-compare-general-info';
import { ProductCompareRelatedProperties } from './product-compare-related-properties';
import { ProductCompareSpecifications } from './product-compare-specifications';
import { ProductCompareTechnicalProperties } from './product-compare-technical-properties';

interface Props {
   locale: string;
   productsBaseRoute: string;
   industryBaseRoute: string;
   products: NormalizedProduct[];
   unitSystem: UnitSystem;
   hasSharedProducts: boolean;
}

const stickyHeaderStyles: CSSProperties = {
   position: 'sticky',
   zIndex: 50,
   top: 'var(--component-navigation-old-navbar-toolbar-container-sizing-min-height-lg)'
};

export const ProductCompareTable = ({ productsBaseRoute, industryBaseRoute, locale, products, unitSystem, hasSharedProducts }: Props) => {
   const totalColumns = products.length + 1; // +1 for the label column
   const { desktop } = useBreakpoint();

   return (
      <Table width="100%" tableLayout="fixed" snapToColumn={!desktop}>
         <TableHead styles={desktop ? stickyHeaderStyles : undefined}>
            <TableRow>
               <TableHeader width="200px">{}</TableHeader>
               {products.map((product, index) => (
                  <ProductCompareCardHeader
                     key={AppUtils.getKey(`card-${product.id}`, index)}
                     product={product}
                     locale={locale}
                     baseRoute={productsBaseRoute}
                     hasSharedProducts={hasSharedProducts}
                  />
               ))}
            </TableRow>
         </TableHead>
         <TableBody>
            <ProductCompareGeneralInfo products={products} totalColumns={totalColumns} />
            <ProductCompareRelatedProperties products={products} industryBaseRoute={industryBaseRoute} totalColumns={totalColumns} locale={locale} />
            <ProductCompareSpecifications products={products} totalColumns={totalColumns} />
            <ProductCompareTechnicalProperties products={products} totalColumns={totalColumns} unitSystem={unitSystem} />
         </TableBody>
      </Table>
   );
};
